module.exports = __webpack_public_path__ + "img/eae-slide-11.f1e74429.jpg";